import { useTranslation } from 'react-i18next'

import { ChatDotsIcon, ImageIcon } from '@phosphor-icons/react'

import { ComboBox, Switch, Text } from '@reveni-io/reveni-ui'

import { additionalContentValues } from './constants'
import { isValidationActive } from './helpers'
import * as Styles from './styles'

const AdditionalContentSection = ({
  notesValidation,
  imageValidation,
  onToggleNotesValidation,
  onToggleImageValidation,
  onChangeNotesValidation,
  onChangeImageValidation,
}) => {
  const { t } = useTranslation()

  const isNotesValidationActive = isValidationActive(notesValidation)
  const isImageValidationActive = isValidationActive(imageValidation)

  const menuItems = additionalContentValues.map(option => ({ ...option, label: t(option.label) }))

  const handleToggleNotes = e => onToggleNotesValidation(e.target.checked)
  const handleToggleImage = e => onToggleImageValidation(e.target.checked)

  const handleChangeNotesValidation = e => onChangeNotesValidation(e.target.value)
  const handleChangeImageValidation = e => onChangeImageValidation(e.target.value)

  return (
    <Styles.Container>
      <Text type="titleS">{t('Contenido adicional')}</Text>
      <Styles.SwitchesContainer>
        <Switch
          checked={isNotesValidationActive}
          onChange={handleToggleNotes}
          label={
            <Styles.SwitchLabel>
              <ChatDotsIcon size={20} />
              {t('Notas')}
            </Styles.SwitchLabel>
          }
        />
        {isNotesValidationActive && (
          <ComboBox
            label={t('Contenido requerido')}
            menuItems={menuItems}
            value={notesValidation}
            handleChange={handleChangeNotesValidation}
          />
        )}
        <Switch
          checked={isImageValidationActive}
          onChange={handleToggleImage}
          label={
            <Styles.SwitchLabel>
              <ImageIcon size={20} />
              {t('Imágenes')}
            </Styles.SwitchLabel>
          }
        />
        {isImageValidationActive && (
          <ComboBox
            label={t('Contenido requerido')}
            menuItems={menuItems}
            value={imageValidation}
            handleChange={handleChangeImageValidation}
          />
        )}
      </Styles.SwitchesContainer>
    </Styles.Container>
  )
}

export default AdditionalContentSection
